function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var _excluded = ["children", "checkboxName", "groupTitle", "hideGroupTitle", "horizontal", "fieldMessage", "hasError", "className"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import React, { Component } from 'react';
import { string, bool, node } from 'prop-types';
import classNames from 'classnames';
import uuid from 'uuid';
import Fieldset from '../Fieldset/Fieldset';
import './CheckboxList.scss';
import FieldMessage from '../FieldMessage/FieldMessage';
var propTypes = {
  children: node.isRequired,

  /** Sets the title of the group (The legend of the fieldset) */
  groupTitle: string.isRequired,

  /** Visually hides the group title. */
  hideGroupTitle: bool,

  /** Sets the name attr on ALL checkboxes in the group. If you don't use this, remember to set a name attr on the checkboxes manually. */
  checkboxName: string,

  /** List the checkboxes horizontally */
  horizontal: bool,

  /** Add your own custom class names to the component */
  className: string
};
var defaultProps = {
  hideGroupTitle: false,
  horizontal: false,
  className: ''
};
/** A list of checkboxes grouped together with a title.
 * @visibleName Checkbox List
 * */

var CheckboxList = /*#__PURE__*/function (_Component) {
  _inherits(CheckboxList, _Component);

  var _super = _createSuper(CheckboxList);

  function CheckboxList(props) {
    var _this;

    _classCallCheck(this, CheckboxList);

    _this = _super.call(this, props);
    _this.fieldMessageId = "rds-checkboxlist-fieldmessage-".concat(uuid.v4());
    return _this;
  }

  _createClass(CheckboxList, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          checkboxName = _this$props.checkboxName,
          groupTitle = _this$props.groupTitle,
          hideGroupTitle = _this$props.hideGroupTitle,
          horizontal = _this$props.horizontal,
          fieldMessage = _this$props.fieldMessage,
          hasError = _this$props.hasError,
          className = _this$props.className,
          rest = _objectWithoutProperties(_this$props, _excluded);

      var childrenInList;

      if (checkboxName) {
        childrenInList = React.Children.map(children, function (child) {
          return /*#__PURE__*/React.createElement("li", {
            className: "rds-checkbox-list__item"
          }, /*#__PURE__*/React.cloneElement(child, {
            name: checkboxName
          }));
        });
      } else {
        childrenInList = React.Children.map(children, function (child) {
          return /*#__PURE__*/React.createElement("li", {
            className: "rds-checkbox-list__item"
          }, child);
        });
      }

      var componentClassNames = classNames('rds-checkbox-list', className);
      var checkboxListClassNames = classNames('rds-checkbox-list__content', {
        'rds-checkbox-list__content--horizontal': horizontal
      });
      return /*#__PURE__*/React.createElement(Fieldset, _extends({
        legend: groupTitle,
        className: componentClassNames,
        hideLegend: hideGroupTitle,
        renderLegendAsLabel: true
      }, fieldMessage && {
        'aria-describedby': this.fieldMessageId
      }, rest), /*#__PURE__*/React.createElement("ul", {
        className: checkboxListClassNames
      }, childrenInList), fieldMessage && /*#__PURE__*/React.createElement(FieldMessage, {
        text: fieldMessage,
        skin: hasError ? 'danger' : null,
        id: this.fieldMessageId
      }));
    }
  }]);

  return CheckboxList;
}(Component);

CheckboxList.propTypes = propTypes;
CheckboxList.defaultProps = defaultProps;
export default CheckboxList;